var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09091 13.1428H13.6364V14.7856H7.09091V13.1428ZM7.09091 9.03564H16.9091V10.6785H7.09091V9.03564ZM7.09091 17.2499H11.1818V18.8928H7.09091V17.2499Z",
    fill: "#7C7C7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3636 2.46429H16.9091V1.64286C16.9091 1.20714 16.7367 0.789277 16.4298 0.481182C16.1229 0.173086 15.7067 0 15.2727 0H8.72727C8.29328 0 7.87707 0.173086 7.57019 0.481182C7.26331 0.789277 7.09091 1.20714 7.09091 1.64286V2.46429H4.63636C4.20237 2.46429 3.78616 2.63737 3.47928 2.94547C3.1724 3.25356 3 3.67143 3 4.10714V21.3571C3 21.7929 3.1724 22.2107 3.47928 22.5188C3.78616 22.8269 4.20237 23 4.63636 23H19.3636C19.7976 23 20.2138 22.8269 20.5207 22.5188C20.8276 22.2107 21 21.7929 21 21.3571V4.10714C21 3.67143 20.8276 3.25356 20.5207 2.94547C20.2138 2.63737 19.7976 2.46429 19.3636 2.46429ZM8.72727 1.64286H15.2727V4.92857H8.72727V1.64286ZM19.3636 21.3571H4.63636V4.10714H7.09091V6.57143H16.9091V4.10714H19.3636V21.3571Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSmall);
export default __webpack_public_path__ + "static/media/report_small.a7ce3c27f343284c897c5fdd0ee700ce.svg";
export { ForwardRef as ReactComponent };